import * as constants from './lib/constants.mjs';
import * as util from './lib/util.mjs';
import * as viewport from './lib/viewport.mjs';
import { loadScript, registerScript } from './lib/script-registration.js';
import { hashState, registerHashStateActions } from './lib/hash-state.mjs';
import { registerLayoutActions, updateLayout } from './lib/event-actions.mjs';
import { registerScrollWatchActions, scrollWatch } from './lib/scroll-watch.mjs';
import { registerHeaderHeightActions } from './lib/header-height.mjs';
import { registerCssVarsActions } from './lib/css-vars.mjs';
import { registerExitIntentActions } from './lib/exit-intent.mjs';
import { registerAccessibilityActions } from './lib/accessibility.mjs';

const init = (cb, priority = 100) => sitchco.hooks.addAction(constants.INIT, cb, priority);
const register = (cb, priority = 100) => sitchco.hooks.addAction(constants.REGISTER, cb, priority);
const ready = (cb, priority = 100) => sitchco.hooks.addAction(constants.READY, cb, priority);

window.sitchco = Object.assign(window.sitchco || {}, {
    constants,
    util,
    viewport,
    loadScript,
    registerScript,
    hashState,
    updateLayout,
    scrollWatch,
    init,
    register,
    ready,
});

// Core components
register(registerHashStateActions);
register(registerLayoutActions);
register(registerScrollWatchActions);
register(registerHeaderHeightActions);
register(registerCssVarsActions);
register(registerExitIntentActions);
register(registerAccessibilityActions);
window.addEventListener('DOMContentLoaded', () => {
    // Use this event if for external or non-explicit dependencies
    document.dispatchEvent(new CustomEvent('sitchco/core/init', window.sitchco));
    // Theme should register here to add any filters
    sitchco.hooks.doAction(constants.INIT);
    // Components should register here so theme can filter
    sitchco.hooks.doAction(constants.REGISTER);
    // Component post-registration actions can happen here
    sitchco.hooks.doAction(constants.READY);
});

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        sitchco.hooks.doAction(constants.RESTORED);
        updateLayout();
        window.dispatchEvent(new Event('scroll'));
    }
});

window.addEventListener('load', () => {
    // Fallback for any cases where fonts.ready fails
    document.documentElement.classList.add('fonts-loaded');
});

// Gravity Forms fires gform_confirmation_loaded as a jQuery custom event.
// Bind inside ready() so jQuery is guaranteed to be loaded (UIFramework script
// can execute before jQuery depending on enqueue order).
ready(() => {
    if (window.jQuery) {
        jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
            sitchco.hooks.doAction(constants.GFORM_CONFIRM, formId);
        });
    }
});
